module.exports = __webpack_public_path__ + "static/media/lastNews.82b34501.svg";